import React, { useState } from "react"
import { Popover } from "react-tiny-popover"
import TickIcon from "../../../assets/icons/tick.svg"
import InfoIcon from "../../../assets/icons/info.svg"
import CustomPopover from "../popover"

const Tab = ({
  name,
  handleTabChange,
  selected,
  className,
  popoverTitle,
  popoverDescription,
  popoverList,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const handleTabClicked = () => {
    handleTabChange(name)
  }

  const handleMouseEnter = () => {
    setIsPopoverOpen(true)
  }

  const handleMouseLeave = () => {
    setIsPopoverOpen(false)
  }

  return (
    <div
      className={`flex w-22 gap-1 h-8 p-2 lg:p-0 md:gap-2 lg:gap-4 md:w-28 lg:w-44 md:h-9 lg:h-11 rounded-full ${
        selected ? "border-2" : "border"
      } ${
        selected ? "border-primary" : "border-gray-400"
      } cursor-pointer ${className} justify-center items-center`}
      onClick={handleTabClicked}>
      <p className="text-xs leading-none lg:text-base font-medium">{name}</p>
      <Popover
        isOpen={isPopoverOpen && !selected}
        positions={["bottom"]}
        align="end"
        containerClassName="z-[100]"
        content={
          <CustomPopover
            title={popoverTitle}
            description={popoverDescription}
            list={popoverList}
          />
        }>
        <img
          src={selected ? TickIcon : InfoIcon}
          alt=""
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </Popover>
    </div>
  )
}

export default Tab
